module.exports = __webpack_public_path__ + "img/voice-thumb13.8e6aae0.jpg";